import React, { Component } from 'react'
import './styles.css'
import Logo from 'images/gettingout_logo.png'

function Header(props) {
  return (
    <div styleName='headerContainer'>
      <img src={Logo} alt="GettingOut Logo" />
    </div>
  )
}

export default Header